import React, { useEffect, useState } from 'react';

import axios from 'axios';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import ReactPixel from 'react-facebook-pixel';

import { Col, Row, Layout } from 'antd';
import { CheckoutForm } from './CheckoutForm';
import { Helmet } from 'react-helmet';

import './App.css';

const { Content } = Layout;

function App(props) {
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [logo, setLogo] = useState("");
  const [id, setId] = useState("");
  const [headline, setHeadline] = useState("");
  const [fontFamily, setFontFamily] = useState("");
  const [description, setDescription] = useState("");
  const [youtubeVideo, setYoutubeVideo] = useState("");
  const [fbPixel, setFbPixel] = useState("");
  const [ageWarning, setAgeWarning] = useState("");
  const [stripePromise, setStripePromise] = useState(() => { });

   const [sid,setSid] = useState("");
   const [subscribeInfo,setSubscribeInfo] = useState();
   const [merchantData , setMerchantData] =useState();
  useEffect(() => {
    const loadSubdomainData = async () => {
      const subdomain = window.location.host.split('.')[1] ?
        window.location.host.split('.')[0] : false;

      // const subdomain = 'newuser'
      const Searchparams = window.location.search.substring(1) ? window.location.search : null ;
      const params = new URLSearchParams(Searchparams)
      const sid = params.get('sid')
      setSid(sid);
      if(sid){
        const subscriberurl = `${props.apiUrl}/subscriber/view/${sid}/`;
        const res = await axios.get(subscriberurl);
        const subscribeInfo = res?.data.subscriber;
        setSubscribeInfo(subscribeInfo);
      
    }


      if (!subdomain) return window.location.href = `/error`;
      const url = `${props.apiUrl}/merchant/landing/${subdomain}`;
      const response = await axios.get(url);
      setMerchantData(response.data)
      setName(response.data.name);
      setLogo(response.data.logo);
      setId(response.data.id);
      setDescription(response.data.description);
      setHeadline(response.data.headline);
      setYoutubeVideo(response.data.youtubeVideo);
      setFontFamily(response.data.fontFamily);
      setFbPixel(response.data.fbPixel);
      setAgeWarning(response.data.ageWarning);
      setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
        stripeAccount: response.data.stripeAccount
      }));
      setLoading(false);
      
      ReactPixel.init(response.data.fbPixel);
      ReactPixel.pageView();
    }

    if (window) loadSubdomainData();
  }, []);

  return !loading && <>
    <Helmet>
      <title>{name}</title>
      <link rel="icon" href={`${logo}?v=2`} />
      <link rel="apple-touch-icon" href={`${logo}?v=2`} />
    </Helmet>
    <Layout>
      <Content style={{ background: `#ffffff` }}>
        <Row>
          <Col span={24}>
            <Elements stripe={stripePromise}>
              <CheckoutForm
                apiUrl={props.apiUrl}
                merchant={merchantData}
                subscriber={sid ? subscribeInfo : null}
                fontFamily={fontFamily}
                ageWarning={ageWarning}
              />
            </Elements>
          </Col>
        </Row>
      </Content>
    </Layout>
  </>;
}

export default App;
